import { call, put, takeEvery } from 'redux-saga/effects';
import { getModelStructure } from '../../requests/get_model_structure_request';
import { getGroupModelPermissions, getGroupModelFieldsPermissions } from '../../requests/get_permissions_request';

import { getModelStructureRequestSuccess, getModelStructureRequestFailure } from '../actions/get_model_structure.actions';
import { GET_MODEL_STRUCTURE_REQUEST } from '../constants/get_group_data.constants';
import { message_error } from '../../../../../components/Message';

function* getModelStructureRequest({ model, id }) {
    const { result, options, error } = yield call(getModelStructure, model);
    const permissionsStructure = yield call(getGroupModelPermissions, id, options.metadata.URL);
    let urls = [];
    result && Object.keys(options.metadata.fields).map(key => urls = [...urls, options.metadata.fields[key].URL]);

    const permissionsFieldsStructure = yield call(getGroupModelFieldsPermissions, id, urls);

    if (result) {
        options.metadata.modelPermissions = permissionsStructure.options[0];
        Object.keys(options.metadata.fields).map(key => permissionsFieldsStructure.options.forEach((option) => {
            if (options.metadata.fields[key].URL === option.url) {
                Object.assign(options.metadata.fields[key], { fieldPermissions: option });
            }
        }));
        yield put(getModelStructureRequestSuccess(options.metadata));
    } else {
        yield put(getModelStructureRequestFailure(error));
        message_error(error);
    }
}

export default function* getModelStructureSaga() {
    yield takeEvery(GET_MODEL_STRUCTURE_REQUEST, getModelStructureRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/sagas/get_model_structure.saga.js